import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ShareActions } from "./ShareActions";

export const DayShareDialog = ({ share, onClose }) => (
  <Dialog open={!!share} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="day-share-dialog" className="max-h-[92vh] overflow-y-auto rounded-2xl sm:max-w-md">
      <DialogHeader>
        <DialogTitle className="font-display">Invia la giornata</DialogTitle>
        <DialogDescription>{share?.subtitle}</DialogDescription>
      </DialogHeader>
      <pre data-testid="day-share-preview" className="max-h-[50vh] overflow-y-auto whitespace-pre-wrap break-words rounded-xl border border-emerald-100 bg-emerald-50/60 p-3 font-sans text-xs leading-relaxed text-slate-700">
        {share?.text}
      </pre>
      {share && <ShareActions text={share.text} testPrefix="day-share" />}
    </DialogContent>
  </Dialog>
);
